import { http } from './config'

export default {

  create: (role_id, permission_id) => {
    return http.post('role_permissions/create', {
      "role_id": role_id,
      "permission_id": permission_id
    })
  },
  
  delete: (role_id, permission_id) => {
    return http.post('role_permissions/delete', {
      "role_id": role_id,
      "permission_id": permission_id
    })
  },
}
